import { render } from "./HelpMenu.vue?vue&type=template&id=6d6f59c7"
import script from "./HelpMenu.vue?vue&type=script&lang=js"
export * from "./HelpMenu.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__